import { Button, styled } from '@mui/material';

import { theme } from 'styles';

export const ButtonMUI = styled(Button)`
  text-transform: none;
  border-radius: 12px;
  padding: 0;
`;

export const FormCancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 24px',
  color: theme.palette.secondary.dark,
  border: `1px solid ${theme.palette.primary.grey}`,
  background: theme.palette.white.main,
  '&:hover': {
    background: theme.palette.white.main,
    border: `1px solid ${theme.palette.primary.grey}`,
  },
}));

export const FormSubmitButton = styled(Button)(() => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 24px',
  color: theme.palette.white.main,
  background: theme.palette.info.main,
  border: 'none',
  '&:hover': { background: theme.palette.info.main },
  '&:disabled': { background: theme.palette.info.main, color: theme.palette.white.main },
}));
